// extracted by css-extract-rspack-plugin
var _1 = "AppInstallBanner-m_banner-wMpWy0K8 common-m_flexRow-ZPndn63a";
var _2 = "AppInstallBanner-m_hideButton-A36AZBrK common-m_resetButton-o3oKAnUN";
export { _1 as "banner", _2 as "hideButton" }
